import React from 'react';
import { withStyles } from '@material-ui/core';
import { Entity } from '@sketchpixy/rubix/lib/L20n';

const styles = () => ({
  titleText: {
    marginRight: 5,
    marginBottom: 5,
    fontSize: 20,
    fontWeight: 'bold',
    color: '#3f3f3f',
    textAlign: 'left',
  },
  sectionText: {
    margin: 0,
    marginRight: 5,
    marginBottom: 15,
    fontSize: 16,
    lineHeight: 1.4,
    color: '#3f3f3f',
    textAlign: 'left',
  },
});

const AccessProfilesExplanationView = ({ classes }) => (
  <div style={{ marginLeft: 13, marginBottom: 30 }}>
    <h2 className={classes.titleText}><Entity entity="whatIsIt" /></h2>
    <h2 className={classes.sectionText}><Entity entity="whatIsItAccessProfileExplanation" /></h2>
    <h2 className={classes.titleText}><Entity entity="howItWorks" /></h2>
    <h2 className={classes.sectionText}><Entity entity="howItWorksAccessProfileExplanation" /></h2>
    <h2 className={classes.titleText}><Entity entity="warning" /></h2>
    <h2 className={classes.sectionText}><Entity entity="accessProfileExplanationWarning" /></h2>
  </div>
);

export default withStyles(styles)(AccessProfilesExplanationView);
